import {
  Text,
  TextProps,
  Font,
  Styles,
  PageProps,
  Page,
  View
} from '@react-pdf/renderer';
import { formatISO } from 'date-fns';
import React from 'react';

Font.register({
  family: 'Comfortaa',
  src: 'https://fonts.gstatic.com/s/comfortaa/v9/qLBu5CQmSMt1H43OiWJ77aCWcynf_cDxXwCLxiixG1c.ttf'
});

/**
 * Define a default style for all text components
 *
 * We need to use `Styles[string]` because the `Style` type is not exported from the `@react-pdf/renderer` library
 */
const defaultStyleProps: Styles[string] = {
  fontFamily: 'Comfortaa',
  lineHeight: 1.2
};

/**
 * Redefine the TextProps type so that it matches the prop-type of the `Text` component
 */
type _TextProps = React.PropsWithChildren<TextProps>;
type _PageProps = React.PropsWithChildren<PageProps>;
export const H1 = (props: _TextProps) => (
  <Text
    {...props}
    style={{
      ...defaultStyleProps,
      lineHeight: 2,
      fontSize: 20
    }}
  />
);

export const H2 = (props: _TextProps) => (
  <Text
    {...props}
    style={{
      ...defaultStyleProps,
      fontSize: 18
    }}
  />
);

export const H3 = (props: _TextProps) => (
  <Text
    {...props}
    style={{
      ...defaultStyleProps,
      fontWeight: 'bold',
      fontSize: 14
    }}
  />
);

export const BodyText = (props: _TextProps) => (
  <Text
    {...props}
    style={{
      ...defaultStyleProps,
      fontSize: 11
    }}
  />
);

export const TableText = (props: _TextProps) => (
  <Text
    {...props}
    style={{
      ...defaultStyleProps,
      lineHeight: 1,
      fontSize: 11
    }}
  />
);

export const SubText = (props: _TextProps) => (
  <Text
    {...props}
    style={{
      ...defaultStyleProps,
      fontSize: 9
    }}
  />
);

export const CRxPDFPage = ({
  children,
  header,
  ...rest
}: _PageProps & { header: { date: Date; diplayName: string } }) => (
  <Page
    {...rest}
    style={{
      ...rest.style,
      padding: 12
    }}
  >
    <View
      style={{
        alignItems: 'flex-end'
      }}
    >
      <SubText>
        ConcussionRx Summary -{' '}
        {formatISO(header.date, { representation: 'date' })} -{' '}
        {header.diplayName.toUpperCase()}
      </SubText>
      <Text
        style={{ fontFamily: 'Comfortaa', fontSize: 9 }}
        render={args => `Page ${args.pageNumber}/${args.totalPages}`}
      />
    </View>
    <View
      style={{
        padding: 24
      }}
    >
      {children}
    </View>
  </Page>
);
